import { Apple, Play, Monitor, Send } from "lucide-react";
import { Mole } from "./Mole";

const STORES = [
  { id: "appstore", icon: Apple, label: "App Store" },
  { id: "googleplay", icon: Play, label: "Google Play" },
  { id: "windows", icon: Monitor, label: "Windows" },
];

const LINKS = [
  { id: "referral", label: "Пригласить друга", href: "/referral" },
  { id: "privacy", label: "Конфиденциальность", href: "/privacy" },
  { id: "terms", label: "Условия использования", href: "/terms" },
  { id: "delete-account", label: "Удаление аккаунта", href: "/delete-account" },
  { id: "support", label: "Поддержка", href: "/support" },
];

export default function Footer() {
  return (
    <footer className="border-t border-nora-ink/10 py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="flex flex-col items-center gap-8 text-center">
          <div className="flex items-center gap-2">
            <Mole variant="hi" className="h-9 w-9" />
            <span className="font-display text-sm font-extrabold tracking-widest">
              NORA
            </span>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {STORES.map((s) => {
              const Icon = s.icon;
              return (
                <a
                  key={s.id}
                  href="#"
                  data-testid={`footer-store-${s.id}`}
                  className="inline-flex items-center gap-2 rounded-full border border-nora-ink/15 px-5 py-2.5 text-sm font-semibold transition-colors hover:border-nora-accent hover:text-nora-accent"
                >
                  <Icon className="h-4 w-4" />
                  {s.label}
                </a>
              );
            })}
          </div>
          <a
            href="https://t.me/NORAVPNcom"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-telegram-link"
            className="inline-flex items-center gap-2 rounded-full border border-nora-mint/30 bg-nora-mint/10 px-5 py-2.5 text-sm font-semibold text-nora-mint transition-colors hover:bg-nora-mint/20"
          >
            <Send className="h-4 w-4" />
            Телеграм-канал — новости и статус сервиса
          </a>
          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3 text-sm text-nora-ink/60">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`footer-link-${l.id}`}
                className="transition-colors hover:text-nora-accent"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <p className="text-xs text-nora-ink/40">
            © 2026 NORA · Кротик присматривает
          </p>
        </div>
      </div>
    </footer>
  );
}
